export function elementIsEmpty(element, strict = true) {
    return strict ? !element.childNodes.length : !element.innerHTML.trim().length;
}
export function elementIsHidden(element) {
    return element.offsetParent === null;
}

export function isVisible(elem) {
    return !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}
export function isElement(element) {
    return element instanceof Element || element instanceof Document || element instanceof Window;
}

export function getElementPosition(element, relativeTo = window) {
    const useElement = typeof element === 'string' ? document.getElementById(element) : element;

    if (!useElement) {
        throw 'getElementPosition did not find an element.';
    }

    const useRelativeTo = typeof relativeTo === 'string' ? document.getElementById(relativeTo) : relativeTo;

    if (!useRelativeTo) {
        throw 'getElementPosition did not find an element to show the position relative to.';
    }

    if (relativeTo === window) {
        const rect = useElement.getBoundingClientRect();
        return {
            top: rect.top + (window.pageYOffset || document.documentElement.scrollTop),
            left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft)
        };
    } else {
        return {
            top: useElement.offsetTop - relativeTo.offsetTop,
            left: useElement.offsetLeft - relativeTo.offsetLeft
        };
    }
}

export function getElementScroll(element = window) {
    if (isElement(element)) {
        if (element instanceof Window) {
            return {
                left: element.pageXOffset || document.documentElement.scrollLeft,
                top: element.pageYOffset || document.documentElement.scrollTop
            };
        } else {
            return {
                left: element.scrollX || element.scrollLeft,
                top: element.scrollY || element.scrollTop
            };
        }
    } else {
        console.warn('Can\'t get scroll-position or given argument type.');
        return false;
    }
}

export function getElementSize(element, options = {}) {
    // Get styles
    const elementStyle = window.getComputedStyle(element, options.pseudoElement);

    return {
        width: getElementWidth(element, options, elementStyle),
        height: getElementHeight(element, options, elementStyle)
    };
}

export function getElementWidth(element, options = {}, elementStyle = null) {
    options.includeMargin = options.includeMargin === true;
    options.includeBorder = options.includeBorder !== false;
    options.includePadding = options.includePadding !== false;

    const style = elementStyle || window.getComputedStyle(element, options.pseudoElement);
    let width = element.offsetWidth;

    if (options.includeMargin) {
        width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    }

    if (!options.includeBorder) {
        width -= parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
    }

    if (!options.includePadding) {
        width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    }

    return width;
}

export function getElementHeight(element, options = {}, elementStyle = null) {
    options.includeMargin = options.includeMargin === true;
    options.includeBorder = options.includeBorder !== false;
    options.includePadding = options.includePadding !== false;

    const style = elementStyle || window.getComputedStyle(element, options.pseudoElement);
    let height = element.offsetHeight;

    if (options.includeMargin) {
        height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    }

    if (!options.includeBorder) {
        height -= parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    }

    if (!options.includePadding) {
        height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    }

    return height;
}
